import { client } from '~/api/client';
import { mutateData } from '~/api/data/request';
import {
  ConfirmAnnualRenewalDocument,
  ConfirmAnnualRenewalMutation,
  ConfirmAnnualRenewalMutationVariables
} from '~/api/graphql';

export const confirmAnnualRenewal = () =>
  mutateData<ConfirmAnnualRenewalMutation, ConfirmAnnualRenewalMutationVariables>(client, {
    mutation: ConfirmAnnualRenewalDocument
  });
